import { render, staticRenderFns } from "./PolymorphicReference.vue?vue&type=template&id=705ba5d1&"
import script from "./PolymorphicReference.vue?vue&type=script&lang=js&"
export * from "./PolymorphicReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports